import {
  Component,
  Input,
  EventEmitter,
  Output,
  HostListener,
  SimpleChanges,
} from '@angular/core';
import { CrosstabService } from 'src/app/common/services/crosstab.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { LoaderService } from 'src/app/common/services/loader.service';
import { AlertMessageService } from 'src/app/common/services/alert-message.service';
import { AlertMessageModel, results } from 'src/app/common/models/common.model';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { CancelEntryPointItem } from '../../models/crosstab.model';

interface VariableList {
  Level0: string;
  isEntryPoint: boolean;
  hasOnlyBrandIndependentChildren: boolean;
  hasOnlyBrandDependentChildren: boolean;
  hasSomeBrandDependentChildrenNotAll: boolean;
  Level1: {
    Level1_value: string;
    is_derived: string;
    is_brand_analysis: number;
    calc_type: string;
    tooltip: string;
    hasNextLevel: boolean;
    data_variable_code: string;
    response_code: string;
    sort_id: string;
    is_multi_punch: string;
    date: string;
    year_code: string;
    is_dimension: string;
    isCustomGrpPresent: string;
    isCustomCalcPresent: string;
    kibanaFilterScript: string;
    customGroupId: string;
    customCalculationId: string;
    dataYearCode: string;
    is_time_Period_Present: string;
    Weekno_forSigcalculation: string;
    //isCustomCalcPresent: string;
    //customCalculationId: string;
  }[];
}

interface MetricOptions {
  Name: string;
  isActive: boolean;
  responseCode: string;
}

interface Config {
  key: string;
  value: boolean;
}
@Component({
  selector: 'app-leftpanel',
  templateUrl: './leftpanel.component.html',
  styleUrls: ['./leftpanel.component.css'],
})
export class LeftpanelComponent {
  $unSubscribeSubmitData1!: Subscription;
  $unSubscribeSubmitData2!: Subscription;
  $unSubscribeSubmitData3!: Subscription;
  Reciveddata: any;
  @Output() BindImageURL = new EventEmitter<any>();
  @Input() ImageURL: string = '';
  @Input() landingdata: any;
  @Input() ReceivedVarData: any;
  @Input() selected_study: string = '';
  @Input() selected_client: string = '';
  @Input() isSavedScenarioSelected: boolean = false;
  dimensionList: string[] = [];
  @Input() isbackButton: boolean = false;
  @Input() isChangeEntryPoint: boolean = false;
  @Input() isCreateCustomGroup: boolean = false;
  @Input() isCustomGroupClick: boolean = false;

  @Input() isCreateCustomCalculation: boolean = false;
  @Input() isCustomCalculationClick: boolean = false;

  @Input() isBrandAnalysis: boolean = false;
  @Input() hidePanel: boolean = false;
  @Input() disableVariables: boolean = false;
  @Input() moduleName: string = 'CrossTab';
  @Input() alertLandingData: any;
  @Input() isLoadSelected: boolean = false;
  @Input() isLoader: boolean = true;
  @Input() isAskMeRedirect: boolean = false;
  @Input() EditAlertEntryList: any = [];
  @Input() isEditAlert:boolean = false;
  @Output() variableDataReady = new EventEmitter<void>();


  custom_calculation: string[] = [];
  custom_group: string[] = [];
  custom_report: string[] = [];
  export_download: string[] = [];
  metricOption: string[] = [];
  isStudyPanel = false;
  levelName: string = '';
  sidePanelblock: boolean = false;
  entryFlag: boolean = false;
  isEntry_Point = false;
  isVariableTab = false;
  isEntry_Tab = true;
  left_panel_collapse: boolean = false;
  is_variable_expand: boolean = false;
  is_load_btn: boolean = true;
  tempIsVariableTab = false;
  dataFormat: string = '';
  mandatoryVariableName: boolean = false;
  /* @Output() isBtnVisible = new EventEmitter<string>();*/
  @Output() selectedVariableLevel1 = new EventEmitter<any>();
  @Output() selectedVariableLevel0 = new EventEmitter<string>();
  @Output() entryListChange: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() dataListChange: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() selectedConfig = new EventEmitter<any>();
  @Output() selectedEntry = new EventEmitter<any>();
  @Output() LeftPanelClick = new EventEmitter<any>();
  @Output() btnVisible = new EventEmitter<any>();
  @Output() dimensionListChange: EventEmitter<any[]> = new EventEmitter<
    any[]
  >();
  @Output() cancelEntryPointChange: EventEmitter<CancelEntryPointItem> =
    new EventEmitter<CancelEntryPointItem>();
  variable_expand: string = '';
  entry_items_expand: string = '';
  entry_items_expand_lvl: boolean = false;
  entry_nested_items_expand: string = '';
  studyname: string = '';
  isLoadSubmitted: boolean = false;
  @Output() valueChange = new EventEmitter<boolean>();
  @Output() sendHelpGuide: EventEmitter<boolean> = new EventEmitter<boolean>();
  isSelectAll: boolean = false;
  isconfigCustomGrpPresent: boolean = false;
  isconfigCustomCalcPresent: boolean = false;
  isSelectAllMetrics: boolean = false;
  selectAllCheck: number = 0;
  entryPanel: {
    Level1: string;
  }[] = [];

  mandatoryVariableMapping: any[] = [];
  dimensionMeta: any[] = [];
  private clientStudyDataLoaded = false;
  private pendingEditAlertVariableLoad = false;


  @Input() dataArray: any[] = [];
  entryPanel_Lvl2: {
    Level1: string;
    Level2: string;
  }[] = [];

  entryPanel_Lvl3: {
    Level: number;
    Level1: string;
    Level2: string;
    MetricOptions: string;
    responseCode: string;
    isActive: boolean;
    variableCode: string;
    e1_variable_code: string;
    e2_variable_code: string;
    e3_variable_code: string;
    mandatory_variable_mapping: any[];
    dimension: any[];
  }[] = [];

  entryList: {
    Level1: string;
    variableCode: string;

    mandatory_variable_mapping: any[];
    dimension: any[];
    NestedEntryArray: {
      Level2: any[];
      MetricOptions: {
        Name: string;
        responseCode: string;
        isActive: boolean;
        e1_variable_code: string;
        e2_variable_code: string;
        e3_variable_code: string;
      }[];
    }[];
    entryDetails: string;
  }[] = [];
  variableList: VariableList[] = [];
  private selectedItem: HTMLElement | null = null;
  dragdropConnected: any = [
    'row',
    'col',
    'rowNest',
    'colNest',
    'filter',
    'customGroup',
    'customCalculation',
    'PreviewTable',
    'customVariable'
  ];
  drag_drop_container = [...this.dragdropConnected];

  searchText: string = '';
  filteredStudies: string[] = [];
  filteredEntryStudies: {
    study_name: string;
    entry_name: string;
    values: any[];
  }[] = [];
  entryArray: string[] = [];
  filterdEntryList: any[] = [];

  NestedEntryPoints = false;
  searchTextLevel2: string = '';
  searchMetricOption: string = '';
  selectedMarketItems: string[] = [];
  searchVariable: string = '';
  leftPanelSearchVariable: string = '';

  showCancelBtn: boolean = false;
  // variableTabData: string[] = [];
  variableTabData: any = [];
  EntryPointHeader = 'ENTRY POINT';
  isAggregatedData: boolean = false;
  isSemiAggregatedData: boolean = false;

  @Input() landingData!: any[];
  clientcode: string = '';
  SelectionObject: {
    Row: {
      Parent: string;
      Data: {
        Child: string;
      }[];
    }[];
    Row_Nest: {
      Parent: string;
      Data: {
        Child: string;
      }[];
    }[];
    Column: {
      Parent: string;
      Data: {
        Child: string;
      }[];
    }[];
    ColumnNest: {
      Parent: string;
      Data: {
        Child: string;
      }[];
    }[];
  }[] = [];
  @Output() isClearEverything = new EventEmitter<boolean>();
  brandIndependentVariableList: VariableList[] = [];
  brandDependentVariableList: VariableList[] = [];
  isBrandIndependentExpanded: boolean = true;
  isBrandDependentExpanded: boolean = true;

  constructor(
    private router: Router,
    private dataSharingService: CrosstabService,
    private crossTabService: CrosstabService,
    private Loader: LoaderService,
    private _alertService: AlertMessageService
  ) {
    this.landingdata = this.router.getCurrentNavigation()?.extras.state;
  }
  ngOnInit() {
    this.dimensionList = [];
    this.entryPanel = [];
    this.variableList = [];
    this.getEntryData();
    this.crossTabService.selectedStudyName.next(this.selected_study);
  }

  ngOnChanges(changes: SimpleChanges): void {
    //whenever load is clicked for particular saved scenario to bind leftpanel data this is called
    // This method will be called whenever there is a change in the @Input properties
    this.showCancelBtn = false;
    if (changes['isSavedScenarioSelected'] && this.isSavedScenarioSelected) {
      this.getVariableData();
    } else if (changes['dataArray'] && this.isSavedScenarioSelected) {
      this.getVariableData();
    } else if (changes['isbackButton'] && this.isbackButton) {
      this.getVariableData();
    } else if (changes['EditAlertEntryList'] && this.isEditAlert) {
      this.dataArray = this.EditAlertEntryList || [];
      // Do NOT call getVariableData until clientStudyDataLoaded=true
     this.Loader.showLoader();
      if (this.clientStudyDataLoaded) {
        this.enrichDataArrayWithMeta();
        if (this.dataArray?.length > 0) {
          this.getVariableData();
        }
      } else {
        this.pendingEditAlertVariableLoad = true;
      }
    } else if (changes['isChangeEntryPoint'] && this.isChangeEntryPoint) {
      this.tempIsVariableTab = false;
      if (this.isVariableTab) this.tempIsVariableTab = true;

      this.isVariableTab = false;
      this.is_load_btn = true;
      this.isEntry_Tab = true;
      this.showCancelBtn = true;
    }
    // else if (changes['isCustomGroupClick'] && this.isCustomGroupClick && this.variableList.length > 0) {
    //   let customObject = this.variableList;
    //   //let listToUpdate = this.customGroupSelectionsObj;

    //   let listToUpdate = customObject.filter(
    //     (a) => a.isEntryPoint != true && a.Level0 != 'Time Period' && a.Level0 != 'Custom Group'
    //   );
    //   this.variableList = listToUpdate;
    // }
    else if (
      changes['isCreateCustomCalculation'] &&
      this.isCreateCustomCalculation &&
      this.variableList.length > 0
    ) {
      const customObject = this.isBrandAnalysis
        ? this.brandDependentVariableList
        : this.variableList;
      const listToUpdate = customObject.filter(
        (a) =>
          a.isEntryPoint != true &&
          a.Level0 != 'Time Period' &&
          a.Level0 != 'Custom Mean Variable - User Defined' &&
          a.Level0 != 'Custom Mean Variable - Shared With Me' &&
          a.Level0 != 'Custom Percentage Variable - User Defined' &&
          a.Level0 != 'Custom Percentage Variable - Shared With Me'
      );
      if (this.isBrandAnalysis) {
        this.brandDependentVariableList = listToUpdate;
      } else {
        this.variableList = listToUpdate;
      }
    } else if (
      changes['isCreateCustomGroup'] &&
      this.isCreateCustomGroup &&
      this.variableList.length > 0
    ) {
      const customObject = this.isBrandAnalysis
        ? this.brandIndependentVariableList
        : this.variableList;
        const customObject1 = this.isBrandAnalysis
        ? this.brandDependentVariableList
        : this.variableList;
      const listToUpdate = customObject.filter(
        (a) =>
          a.isEntryPoint != true &&
          a.Level0 != 'Time Period' &&
          a.Level0 != 'Custom Percentage Variable - User Defined' &&
          a.Level0 != 'Custom Percentage Variable - Shared With Me'&&
          a.Level0 != 'Custom Mean Variable - User Defined' &&
          a.Level0 != 'Custom Mean Variable - Shared With Me'
      );
      const listToUpdate1 = customObject1.filter(
        (a) =>
          a.isEntryPoint != true &&
          a.Level0 != 'Time Period' &&
          a.Level0 != 'Custom Percentage Variable - User Defined' &&
          a.Level0 != 'Custom Percentage Variable - Shared With Me' &&
          a.Level0 != 'Custom Mean Variable - User Defined' &&
          a.Level0 != 'Custom Mean Variable - Shared With Me'
      );
      if (this.isBrandAnalysis) {
        this.brandIndependentVariableList = listToUpdate;
        this.brandDependentVariableList = listToUpdate1;
      } else {
        this.variableList = listToUpdate;
      }
    }
    if (changes['hidePanel']) {
      this.sidePanelblock = false;
      this.entry_items_expand = '';
      this.variable_expand = '';
    }
    // else if (changes['isCustomGroupClick'] && this.isCustomGroupClick && this.variableTabData.length > 0) {
    //   this.BindVariableDataLeftPanel(this.variableTabData);
    //   this.crossTabService.setVariableTabData(this.variableTabData);
    // }
  }
  ngOnDestroy() {
    if (this.$unSubscribeSubmitData1) {
      this.$unSubscribeSubmitData1.unsubscribe();
    }
    if (this.$unSubscribeSubmitData2) {
      this.$unSubscribeSubmitData2.unsubscribe();
    }
    if (this.$unSubscribeSubmitData3) {
      this.$unSubscribeSubmitData3.unsubscribe();
    }
  }

  errorPopup(message: string, headerTxt: string = 'Error'): void {
    const alertObj: AlertMessageModel = {
      header: headerTxt,
      message: message,
      show: true,
    };
    this._alertService.showAlert(alertObj);
  }

  togglePanel(Name: string, SelectedValue: string) {
    if (Name == 'study') {
      this.isStudyPanel = !this.isStudyPanel;
      this.isEntry_Point = false;
      this.entry_items_expand = '';
      this.sidePanelblock = false;
    }
  }
  selectedStudy(Name: string) {
    this.studyname = Name;
    this.selected_study = Name;
    this.isStudyPanel = true;
    this.configChanges(this.Reciveddata, Name);
    this.BindEntryData(this.Reciveddata, Name, this.selected_client, true);
    this.crossTabService.selectedStudyName.next(this.selected_study);
  }
  collapsePanel() {
    this.left_panel_collapse = true;
    this.valueChange.emit(this.left_panel_collapse);
  } 
  expandPanel() {
    this.left_panel_collapse = false;
    this.valueChange.emit(this.left_panel_collapse);
  }
  variableExpand(variableName: string) {
    this.searchVariable = '';
    this.isStudyPanel = false;
    if (this.is_variable_expand && this.variable_expand == variableName) {
      this.is_variable_expand = false;
      this.variable_expand = '';
    } else {
      this.variable_expand = variableName;
      this.is_variable_expand = true;
    }
  }
  toggleVariableSection(section: 'BrandIndependent' | 'BrandDependent', event: Event): void {
  event.stopPropagation();
  if (section === 'BrandIndependent') {
    this.isBrandIndependentExpanded = !this.isBrandIndependentExpanded;
    if (!this.isBrandIndependentExpanded) {
      this.variable_expand = '';
      this.is_variable_expand = false;
    }
  } else {
    this.isBrandDependentExpanded = !this.isBrandDependentExpanded;
    if (!this.isBrandDependentExpanded) {
      this.variable_expand = '';
      this.is_variable_expand = false;
    }
  }
}

  displayBucketConditionCheck(variable: any, module: string = 'dataExplorer') {
    if (this.isCreateCustomCalculation) {
      var isMeanAvailable =
        variable.Level1.filter((item: any) => item.calc_type === 'mean')
          .length > 0;

      return !isMeanAvailable;
    } else {
      var condition1 = !this.isDropDownDataAvailable(variable, module);
      return condition1;
    }
  }

  private getBucketRelevantLevel1(level1Items: any[], module: string): any[] {
    if (module === 'brandIndependent') {
      return level1Items.filter((x: any) =>
        ((!(x.calc_type?.toString() === 'mean' && this.isCreateCustomCalculation) && !this.isCreateCustomGroup) &&
          (x.is_brand_analysis === 0 || x.is_brand_analysis === 7)) ||
        ((!(x.calc_type?.toString() === 'mean' && this.isCreateCustomGroup) &&
          (x.is_brand_analysis === 0 || x.is_brand_analysis === 7)) && !this.isCreateCustomCalculation)
      );
    }
    if (module === 'brandDependent') {
      return level1Items.filter((x: any) =>
        (x.is_brand_analysis === 0 && x.isCustomGrpPresent === 'true') ||
        ((x.calc_type?.toString() === 'mean' && this.isCreateCustomCalculation && !this.isCreateCustomGroup) &&
          (x.is_brand_analysis !== 0 && x.is_brand_analysis !== 7)) ||
        ((!(x.calc_type?.toString() === 'mean' && this.isCreateCustomGroup) &&
          (x.is_brand_analysis !== 0 && x.is_brand_analysis !== 7)) && !this.isCreateCustomCalculation)
      );
    }
    return level1Items;
  }
  isDropDownDataAvailable(dropDownData: any, module: string = 'dataExplorer') {
    const searchValue = (this.leftPanelSearchVariable || '').toLowerCase().trim();

    const parentLevel0Value = (
      dropDownData?.Level0 ||
      dropDownData?.Level0_value ||
      ''
    )
      .toString()
      .toLowerCase();

    let level1Items = Array.isArray(dropDownData?.Level1)
      ? dropDownData.Level1
      : Array.isArray(dropDownData)
      ? dropDownData
      : [];

    level1Items = this.getBucketRelevantLevel1(level1Items, module);

    if (parentLevel0Value.includes(searchValue)) {
      return level1Items.length > 0;
    }

    var filteredData: any = _.filter(level1Items, (item: any) => {
      const level1Value = (item?.Level1_value || '').toString().toLowerCase();
      const level0Value = (item?.Level0_value || '').toString().toLowerCase();

      return (
        level1Value.includes(searchValue) || level0Value.includes(searchValue)
      );
    });
    return filteredData.length > 0;
  }

  isLevel1VisibleForSearch(level1: any, variable: any): boolean {
    const localSearchValue = (this.searchVariable || '').toLowerCase().trim();
    if (localSearchValue) {
      return (level1?.Level1_value || '')
        .toString()
        .toLowerCase()
        .includes(localSearchValue);
    }

    const globalSearchValue = (this.leftPanelSearchVariable || '')
      .toLowerCase()
      .trim();
    if (!globalSearchValue) {
      return true;
    }

    const parentLevel0Value = (variable?.Level0 || variable?.Level0_value || '')
      .toString()
      .toLowerCase();
    if (parentLevel0Value.includes(globalSearchValue)) {
      return true;
    }

    return (level1?.Level1_value || '')
      .toString()
      .toLowerCase()
      .includes(globalSearchValue);
  }

  onItemClicked(event: MouseEvent) {
    if (this.selectedItem) {
      this.selectedItem.classList.remove('clicked');
    }
    this.selectedItem = event.currentTarget as HTMLElement;

    const hasNextLevelValue = this.selectedItem
      .getAttribute('data-hasNextLevel')
      ?.toString();
    const has_nextLevel = hasNextLevelValue === 'true'; // Consider 'true' as true, anything else as false

    const dimension = this.selectedItem
      .getAttribute('data-is_dimension')
      ?.toString();
    const is_dimension = dimension === 'true'; // Consider 'true' as true, anything else as false

    const iscustomGrpPresent = this.selectedItem
      .getAttribute('data-is_CustomGroup')
      ?.toString();
    const is_custmGrpPresent = iscustomGrpPresent === 'true';

    const iscustomCalcPresent = this.selectedItem
      .getAttribute('data-is_CustomCalculation')
      ?.toString();
    const is_custmCalcPresent = iscustomCalcPresent === 'true';

    const isTimePeriodPresent = this.selectedItem
      .getAttribute('data-is_time_Period_Present')
      ?.toString();
    const is_Time_Period_Present = isTimePeriodPresent === 'true';
    this.selectedVariableLevel1.emit({
      tooltip: this.selectedItem.title,
      title: this.selectedItem.getAttribute('data-variable-name')?.toString(),
      Parent: this.selectedItem.getAttribute('data-attr')?.toString(),
      is_derived: this.selectedItem.getAttribute('data-is_derived')?.toString(),
      is_brand_analysis: this.selectedItem.getAttribute(
        'data-is_brand_analysis'
      ),
      is_calc_type: this.selectedItem
        .getAttribute('data-calc_type')
        ?.toString(),
      has_nextLevel,
      data_variable_code: this.selectedItem
        .getAttribute('data_variable_code')
        ?.toString(),
      data_response_code: this.selectedItem
        .getAttribute('data_response_code')
        ?.toString(),
      data_sort_id: this.selectedItem.getAttribute('data_sort_id')?.toString(),
      data_is_multi_punch: this.selectedItem
        .getAttribute('data_is_multi_punch')
        ?.toString(),
      data_date: this.selectedItem.getAttribute('data_date')?.toString(),
      data_year_code: this.selectedItem
        .getAttribute('data_year_code')
        ?.toString(),
      is_dimension,
      is_entrypoint: this.selectedItem.getAttribute('data-isEntryPoint')=='true'?true:false,
      is_custmGrpPresent,
      is_custmCalcPresent: is_custmCalcPresent,
      data_kibanaFilterScript: this.selectedItem
        .getAttribute('data-kibanaFilterScript')
        ?.toString(),
      data_customGroupId: this.selectedItem
        .getAttribute('data-customGroupId')
        ?.toString(),
      data_customCalculationId: this.selectedItem
        .getAttribute('data-customCalculationId')
        ?.toString(),
      dataYearCode: this.selectedItem
        .getAttribute('data-dataYearCode')
        ?.toString(),
      is_Time_Period_Present,
      data_Weekno_forSigcalculation: this.selectedItem
        .getAttribute('data-Weekno_forSigcalculation')
        ?.toString(),
    });

    this.selectedItem.classList.add('clicked');
  }
  loadBtnClick(isZeroEntryPoint: boolean) {
    this.isStudyPanel = false;
    this.isLoadSelected = false;

    const allEntryPointsSelected = this.entryPanel.every((ep, index) => {
      const entryPointKey = `EntryPoint${index + 1}`;
      const entryData = this.dataArray.find(entry => entry.hasOwnProperty(entryPointKey));
      return entryData && entryData[entryPointKey].Level2?.some(
        (l2: any) => l2.MetricOptions && l2.MetricOptions.length > 0
      );
    });

    if (isZeroEntryPoint && !allEntryPointsSelected) {
      this.getValidation('EntryPoint');
      return;
    }
 else {
      this.isVariableTab = true;
      this.is_load_btn = false;
      this.isEntry_Tab = false;
      this.sidePanelblock = false;
      this.isEntry_Point = false;
      this.entry_items_expand = '';

      this.btnVisible.emit({
        save: true,
        load: true,
        custom_groups: this.isconfigCustomGrpPresent ? true : false,
        custom_calc: this.isconfigCustomCalcPresent ? true : false,
        create_table: true,
        weighted_btns: true,
      });

      //this.isBtnVisible.emit('save');
      //this.isBtnVisible.emit('custom_groups');
      //this.isBtnVisible.emit('custom_calc');
      //this.isBtnVisible.emit('create_table');
      //this.isBtnVisible.emit('weighted_btns');
      this.entryListChange.emit(this.entryPanel);
      this.dataListChange.emit(this.dataArray);
      this.dimensionListChange.emit(this.dimensionList);
      this.getVariableData();
      //disable Study Dropdown click Event
      this.isLoadSubmitted = true;
      this.showCancelBtn = false;
    }
  }

  DisableNoChildsinCrosstab(Data:any){
      let count = 0;
      if(Data!=null && Data!=undefined){
         Data.filter((x:any)=>{
              if(((x.calc_type.toString() === 'mean' && this.isCreateCustomCalculation)&&(!this.isCreateCustomGroup)) || (!(x.calc_type.toString()=== 'mean' && this.isCreateCustomGroup) && (!this.isCreateCustomCalculation))){
                  count++;
              }
         })
      }
         if(count > 0)
            return true;
         else
            return false;
  }

   DisableNoChildsinBA2(Data:any){
      let count = 0;
      if(Data!=null && Data!=undefined){
         Data.filter((x:any)=>{
              if(((x.is_brand_analysis == 0 && x.isCustomGrpPresent == 'true') || ((x.calc_type.toString() === 'mean' && this.isCreateCustomCalculation)&&(!this.isCreateCustomGroup))&&( x.is_brand_analysis !== 0 && x.is_brand_analysis !== 7) ) || ((!(x.calc_type.toString()=== 'mean' && this.isCreateCustomGroup)&& (x.is_brand_analysis != 0 && x.is_brand_analysis !== 7)) && (!this.isCreateCustomCalculation))){
                  count++;
              }
         })
      }
         if(count > 0)
            return true;
         else
            return false;
  }

   DisableNoChildsinBA(Data:any){
      let count = 0;
      if(Data!=null && Data!=undefined){
         Data.filter((x:any)=>{
              if(((!(x.calc_type.toString() === 'mean' && this.isCreateCustomCalculation)&&(!this.isCreateCustomGroup))&&( x.is_brand_analysis === 0|| x.is_brand_analysis === 7) ) || ((!(x.calc_type.toString()=== 'mean' && this.isCreateCustomGroup)&& (x.is_brand_analysis === 0|| x.is_brand_analysis === 7)) && (!this.isCreateCustomCalculation))){
                  count++;
              }
         })
      }
         if(count > 0)
            return true;
         else
            return false;
  }

  OnCancelBtnClick() {
    this.showCancelBtn = false;

    if (this.tempIsVariableTab) {
      this.isVariableTab = true;
      this.is_load_btn = false;
      this.isEntry_Tab = false;
    } else {
      this.dataArray = [];
    }
    let cancelData: CancelEntryPointItem = {
      isCancel: true,
      isVariableTab: this.isVariableTab,
    };
    this.cancelEntryPointChange.emit(cancelData);
  }

  toggleMetricOptions(
    Level1: any,
    nestedEntry: any,
    event: MouseEvent,
    entryDetails: string
  ) {
    this.sidePanelblock = true;
    this.variable_expand = '';
    this.entry_nested_items_expand = nestedEntry;
    this.selectedItem = event.currentTarget as HTMLElement;

    this.metricOption = [];
    this.dataArray.forEach((entry) => {
      const metricOptionsList = entry['EntryPoint1']?.MetricOptions || [];

      metricOptionsList.forEach((data: MetricOptions) => {
        this.metricOption.push(data.Name);
      });
    });

    const uniqueMetricOptionsArray =
      entryDetails == 'entry1' ? [] : this.metricOption;

    if (this.entryList.length > 0) {
      const EntryData = _.filter(
        this.entryList,
        (item) =>
          item.Level1 !== null && item.Level1 !== '' && item.Level1 === Level1
      );
      if (uniqueMetricOptionsArray.length > 0) {
        if (EntryData.length > 0) {
          this.filterdEntryList = _.filter(
            EntryData[0].NestedEntryArray,
            (item) => item.Level2 !== null && item.Level2 === nestedEntry
          );

          this.filterdEntryList =
            EntryData[0].NestedEntryArray[0].MetricOptions.filter(
              (option: any) => {
                const optionCodes = option.e2_variable_code
                  .split(',')
                  .map((code: any) => code.trim());
                return optionCodes.some((code: any) =>
                  uniqueMetricOptionsArray.includes(code)
                );
              }
            );
        }
      } else {
        if (EntryData.length > 0) {
          this.filterdEntryList = _.filter(
            EntryData[0].NestedEntryArray,
            (item) => item.Level2 !== null && item.Level2 === nestedEntry
          );
        }
      }
    }
  }
  onSearchLevel(Name: string) {
    this.sidePanelblock = false;
    this.entry_nested_items_expand = '';
  }
  shouldHideItem(item: string): boolean {
    return item.toString().includes(this.searchMetricOption);
  }

  setMandatoryVariable(Data:any,Module:any) {
    this.mandatoryVariableName = false;
    let isMandatory:any;
    for (const variable of Data) {
      if(Module == 'brandAnalysis'){
         isMandatory =
        this.dataFormat === 'Respondent Level' &&
        (
          (variable.isEntryPoint && (variable.Level0 === 'Time Period' || variable.isEntryPoint)) ||
          (!variable.isEntryPoint && (this.IsDimension(variable.Level0) || variable.Level0 === 'Time Period'))
        ) && variable.Level0!='Weight Metrics' && !(this.displayBucketConditionCheck(variable,'brandAnalysis'));
      }
      else{
         isMandatory =
          this.dataFormat === 'Respondent Level' &&
          (
            (variable.isEntryPoint && (variable.Level0 === 'Time Period' || variable.isEntryPoint)) ||
            (!variable.isEntryPoint && (this.IsDimension(variable.Level0) || variable.Level0 === 'Time Period'))
          ) && variable.Level0!='Weight Metrics' && !(this.displayBucketConditionCheck(variable));
      }
  
      if (isMandatory) {
        this.mandatoryVariableName = true;
        return true;
      }
    }
    return false;
  }

  checkBoxClick(
    index: number,
    Level: number,
    Header: string,
    Level1: string,
    Level2: string,
    MetricOptions: string,
    variableCode: string,
    responseCode: string,
    mandatory_variable_mapping: any[],
    isSelectAll: boolean,
    e1_variable_code: string,
    e2_variable_code: string,
    e3_variable_code: string,
    dimension: any[]
  ): void {
    const entryPointKey =
      Level === 0 ? 'EntryPoint1' : Level === 1 ? 'EntryPoint2' : 'EntryPoint3';

    if (Level === 0) {
      const entryPoint2Index = this.dataArray.findIndex((entry) =>
        entry.hasOwnProperty('EntryPoint2')
      );
      if (entryPoint2Index !== -1) {
        const entryPoint2 = this.dataArray[entryPoint2Index];

        const level2Index = entryPoint2['EntryPoint2'].Level2.findIndex(
          (l2: any) =>
            l2.MetricOptions.some(
              (mo: any) => mo.Dependency_e1 === e1_variable_code
            )
        );

        if (level2Index !== -1) {
          entryPoint2['EntryPoint2'].Level2.forEach((l2: any) => {
            l2.MetricOptions = l2.MetricOptions.filter(
              (mo: any) => mo.Dependency_e1 !== e1_variable_code
            );
          });

            // Check if Level2 length is 0, then remove the entire entryPoint2
            if (
              entryPoint2['EntryPoint2'].Level2[level2Index].MetricOptions
                .length === 0
            ) {
              entryPoint2['EntryPoint2'].Level2.splice(level2Index, 1);

              // Check if Level2 length is 0, then remove the entire entryPoint2
              if (entryPoint2['EntryPoint2'].Level2.length === 0) {
                this.dataArray.splice(entryPoint2Index, 1);

                const entryPoint3Index = this.dataArray.findIndex((entry) =>
                  entry.hasOwnProperty('EntryPoint3')
                );

                if (entryPoint3Index !== -1) {
                  this.dataArray.splice(entryPoint3Index, 1);
                }
              }
            }
        }
        //const recordIndexToRemove = entryPoint2['EntryPoint2'].Level2.findIndex(
        //  (l2: any) =>
        //    l2.MetricOptions.some(
        //      (mo: any) => mo.Dependency === MetricOptions
        //    )
        //);
        //if (recordIndexToRemove !== -1) {
        //  entryPoint2['EntryPoint2'].Level2.splice(recordIndexToRemove, 1);
        //}
        //if (entryPoint2['EntryPoint2'].Level2.length === 0) {
        //  this.dataArray.splice(entryPoint2Index, 1);
        //}
      }

      const entryPoint3Index = this.dataArray.findIndex((entry) =>
        entry.hasOwnProperty('EntryPoint3')
      );
      if (entryPoint3Index !== -1) {
        const entryPoint3 = this.dataArray[entryPoint3Index];

        const level2Index = entryPoint3['EntryPoint3'].Level2.findIndex(
          (l2: any) =>
            l2.MetricOptions.some(
              (mo: any) => mo.Dependency_e1 === e1_variable_code
            )
        );

        if (level2Index !== -1) {
          entryPoint3['EntryPoint3'].Level2.forEach((l2: any) => {
            l2.MetricOptions = l2.MetricOptions.filter(
              (mo: any) => mo.Dependency_e1 !== e1_variable_code
            );
          });

            // Check if Level2 length is 0, then remove the entire entryPoint3
            if (
              entryPoint3['EntryPoint3'].Level2[level2Index].MetricOptions
                .length === 0
            ) {
              entryPoint3['EntryPoint3'].Level2.splice(level2Index, 1);

              // Check if Level2 length is 0, then remove the entire entryPoint2
              if (entryPoint3['EntryPoint3'].Level2.length === 0) {
                this.dataArray.splice(entryPoint3Index, 1);
              }
            }
        }
      }
    } else if (Level === 1) {
      const entryPoint3Index = this.dataArray.findIndex((entry) =>
        entry.hasOwnProperty('EntryPoint3')
      );
      if (entryPoint3Index !== -1) {
        const entryPoint3 = this.dataArray[entryPoint3Index];

        const level2Index = entryPoint3['EntryPoint3'].Level2.findIndex(
          (l2: any) =>
            l2.MetricOptions.some(
              (mo: any) => mo.Dependency_e2 === e2_variable_code
            )
        );

        if (level2Index !== -1) {
          entryPoint3['EntryPoint3'].Level2.forEach((l2: any) => {
            l2.MetricOptions = l2.MetricOptions.filter(
              (mo: any) => mo.Dependency_e2 !== e2_variable_code
            );
          });

            // Check if Level2 length is 0, then remove the entire entryPoint3
            if (
              entryPoint3['EntryPoint3'].Level2[level2Index].MetricOptions
                .length === 0
            ) {
              entryPoint3['EntryPoint3'].Level2.splice(level2Index, 1);

              // Check if Level2 length is 0, then remove the entire entryPoint3
              if (entryPoint3['EntryPoint3'].Level2.length === 0) {
                this.dataArray.splice(entryPoint3Index, 1);
              }
            }
        }
      }
    }
    const existingEntryIndex = this.dataArray.findIndex(
      (entry) =>
        entry.hasOwnProperty(entryPointKey) &&
        entry[entryPointKey].Level1 === Level1
    );

    if (existingEntryIndex !== -1) {
      // Entry with the same entryPointKey and Level1 exists
      const existingEntry = this.dataArray[existingEntryIndex];

      // Check if Level2 is different
      const existingLevel2Index = existingEntry[entryPointKey].Level2.findIndex(
        (l2: any) => l2.Parent === Level2
      );

      if (existingLevel2Index !== -1) {
        // Level2 with the same Parent exists
        const existingMetricOptionIndex = existingEntry[entryPointKey].Level2[
          existingLevel2Index
        ].MetricOptions.findIndex((mo: any) => mo.Name === MetricOptions);

        if (existingMetricOptionIndex !== -1) {
          // MetricOptions is the same, remove it
          if (isSelectAll == false) {
            existingEntry[entryPointKey].Level2[
              existingLevel2Index
            ].MetricOptions.splice(existingMetricOptionIndex, 1);
          }
        } else {
          // MetricOptions is different, push it to the existing MetricOptions array

          const existingMetricOptionIndex = existingEntry[
            entryPointKey
          ].Level2.findIndex((mo: any) => {
            const existingMetricOptions = mo.MetricOptions;
            return existingMetricOptions.some(
              (existingMo: any) => existingMo.Name === MetricOptions
            );
          });

          if (existingMetricOptionIndex !== -1) {
            if (isSelectAll == false) {
            }
          } else {
            existingEntry[entryPointKey].Level2[
              existingLevel2Index
            ].MetricOptions.push({
              Name: MetricOptions,
              responseCode: responseCode,
              isActive: true,
              Dependency_e1: e1_variable_code,
              Dependency_e2: e2_variable_code,
            });
          }
        }
      } else {
        const existingMetricOptionIndex = existingEntry[
          entryPointKey
        ].Level2.findIndex((mo: any) => {
          const existingMetricOptions = mo.MetricOptions;
          return (
            existingMetricOptions.findIndex(
              (existingMo: any) => existingMo.Name === MetricOptions
            ) !== -1
          );
        });

        if (existingMetricOptionIndex !== -1) {
          if (isSelectAll == false) {
            const metricOptionIndex = existingEntry[entryPointKey].Level2[
              existingMetricOptionIndex
            ].MetricOptions.findIndex(
              (existingMo: any) => existingMo.Name === MetricOptions
            );
            existingEntry[entryPointKey].Level2[
              existingMetricOptionIndex
            ].MetricOptions.splice(metricOptionIndex, 1);
          }
        } else {
          // Level2 is different, push new Level2 and MetricOptions
          existingEntry[entryPointKey].Level2.push({
            Parent: Level2,
            MetricOptions: [
              {
                Name: MetricOptions,
                responseCode: responseCode,
                isActive: true,
                Dependency_e1: e1_variable_code,
                Dependency_e2: e2_variable_code,
              },
            ],
          });
        }
      }
    } else {
      // Create a new entry
      const tempEntry = {
        [entryPointKey]: {
          Level1: Level1,
          Level2: [
            {
              Parent: Level2,
              MetricOptions: [
                {
                  Name: MetricOptions,
                  responseCode: responseCode,
                  isActive: true,
                  Dependency_e1: e1_variable_code,
                  Dependency_e2: e2_variable_code,
                },
              ],
            },
          ],
          variableCode: variableCode,
        },
        clientName: this.selected_client,
        studyName: this.selected_study,
        mandatory_variable_mapping: this.isEditAlert
              ? this.mandatoryVariableMapping
              : mandatory_variable_mapping,
        dimension: this.isEditAlert ? this.dimensionMeta : dimension,
    
      };
      this.dataArray.push(tempEntry);
    }
    if (this.isEditAlert) {
    this.enrichDataArrayWithMeta();
  }
    const existingEntryIndex1 = this.dataArray.findIndex(
      (entry) =>
        entry.hasOwnProperty(entryPointKey) &&
        entry[entryPointKey].Level1 === Level1
    );

    const existingEntry = this.dataArray[existingEntryIndex1];

    const existingLevel2Index = existingEntry[entryPointKey].Level2.findIndex(
      (l2: any) => l2.Parent === Level2
    );
    if (
      this.entryPanel_Lvl3.filter(
        (a) => a.Level1 === Level1 && a.Level2 === Level2
      ).length ===
      (existingLevel2Index !== -1
        ? existingEntry[entryPointKey].Level2[existingLevel2Index]
          .MetricOptions.length
        : 0) &&
      isSelectAll == false
    ) {
      this.isSelectAll = true;
    } else {
      if (isSelectAll == false) {
        this.isSelectAll = false;
      }
    }
    this.ClearAll();
    
this.dataArray = this.dataArray.filter(entry => {
  const key = Object.keys(entry).find(k => k.startsWith('EntryPoint'));
  if (!key) return false;

  const ep = entry[key];

  return (
    ep.Level2 &&
    ep.Level2.some((l2: any) => l2.MetricOptions && l2.MetricOptions.length > 0)
  );
});


if (this.dataArray.length === 0) {
  this.isSelectAll = false;
}
  }

  toggleStatus(
    Level: number,
    Level1: string,
    Level2: string,
    MetricOptions: string
  ): boolean {
    const entryPointKey =
      Level === 0 ? 'EntryPoint1' : Level === 1 ? 'EntryPoint2' : 'EntryPoint3';
    const entry = this.dataArray.find(
      (entry) =>
        entry.hasOwnProperty(entryPointKey) &&
        entry[entryPointKey].Level1 === Level1 &&
        entry[entryPointKey].Level2.some((l2: any) =>
          l2.MetricOptions.some((mo: any) => mo.Name === MetricOptions)
        )
    );
    if (entry) {
      // If entry is found, increment selectAllCheck
      this.selectAllCheck++;
    }

    //if (this.entryPanel_Lvl3.length == this.selectAllCheck) {
    //  this.isSelectAll = true;
    //}
    //else {
    //  this.isSelectAll = false;
    //}
    return entry ? true : false;
  }

  getValidation(Name: string): boolean {
    if (Name == 'Duplicate') {
      this.errorPopup('Already Exist');
    } else if (Name == 'EntryPoint') {
      this.errorPopup(
        'At least one option has to be selected from each Entry Point.'
      );
    }
    return false;
  }
  getEntryData(): void {
    if(this.isLoader){
    this.Loader.showLoader();
    }
    let landingData: any = {};
    let landingDataPoint = false;
    if(this.moduleName == 'Custom SnapShot'){
      landingData.study = this.dataArray[0]?.studyName || this.selected_study ;
      landingData.client_code = this.dataArray[0]?.clientName || this.selected_client;
      if(!this.dataArray[0]?.studyName){
        landingDataPoint =  true;
      }
    }
    else if(this.moduleName == 'Brand Analysis'){
     landingData.study = this.selected_study;
     landingData.client_code = this.selected_client;
    }else if(this.moduleName == 'Alert'){
      landingData.study = this.alertLandingData.study;
     landingData.client_code = this.alertLandingData.client_code;
    }
    else if (this.isAskMeRedirect) {
      landingData = this.landingdata || {
        study: this.selected_study,
        client_code: this.selected_client
      };
    }
    else{
      landingData = this.landingdata;
    }
    this.selected_study = landingData?.study;
    this.selected_client = landingData?.client_code;

    this.$unSubscribeSubmitData1 = this.crossTabService
      .getClientStudyData(landingData, this.isBrandAnalysis)
      .subscribe((result: results) => {
        if (result.HasValidData) {
          this.Reciveddata = JSON.parse(result.Data);
          this.crossTabService.entrypointsData=JSON.parse(result.Data);
          this.clientcode = this.selected_client;
          this.clientStudyDataLoaded = true;

          if (this.Reciveddata.length > 0) {
            this.ImageURL = this.Reciveddata[0].url_logo;
            this.BindImageURL.emit({
              Image: this.ImageURL,
            });
            this.configChanges(this.Reciveddata, this.selected_study);
            this.entryPanel = [];
            this.variableList = [];
            this.BindEntryData(
              this.Reciveddata,
              this.selected_study,
              this.selected_client,
              true,
              landingDataPoint
            );

             if (this.isEditAlert) {
            // If left panel API provided dimension list (root level)
            const first = this.Reciveddata[0];
            if (first?.dimension && Array.isArray(first.dimension)) {
              this.dimensionMeta = first.dimension;
            }
            // Ensure any existing edit alert entries have meta arrays
            this.enrichDataArrayWithMeta();
            if (this.pendingEditAlertVariableLoad && this.dataArray?.length > 0) {
              this.pendingEditAlertVariableLoad = false;
              // bind entry point details - eDependency_e1 and Dependency_e2
              this.bindEntryPointDetailsForAlert(this.Reciveddata);
              this.getVariableData();
            }
          }

            let EntryData = this.Reciveddata.filter(
              (a: any) => a.Level1 != '' && a.study == this.selected_study
            );

            if (this.entryPanel.length > 0) {
              this.selectedEntry.emit({
                entryPanelData: this.entryPanel,
              });
            }
            if (EntryData.length > 0) {
              if (!this.isEditAlert && !this.isAskMeRedirect) {
                this.Loader.hideLoader();
              }
            }
          //   if(this.dataArray.length>0 && this.moduleName=='CrossTab'){
          //      this.loadBtnClick(false);
          //  }
          }
        } else {
          this.Loader.hideLoader();
        }
      });
  }

  bindEntryPointDetailsForAlert(entryPointData: any) {
    for (const item of this.dataArray) {
      const epKey = Object.keys(item).find((k) => k.startsWith("EntryPoint"));
      if (!epKey) continue;

      const epData = item[epKey];
      const level1 = epData.Level1;

      for (const level of epData.Level2) {
        for (const metric of level.MetricOptions) {
          const match = entryPointData.find(
            (ep: any) => ep.Level1 === level1 && ep.MetricOption === metric.Name
          );

          if (match) {
            metric.Dependency_e1 = match.e1_variable_code;
            metric.Dependency_e2 = match.e2_variable_code;
            level.Parent = match.Level2; // update Parent from Level2 field
          }
        }
      }
    }
  }

  configChanges(data: any, study: any) {
    let comparisionpoint;
    let confidenceLevel;
    let weights;
    let dataFormat;
    data = data.filter((a: any) => a.study == study);
    if (data.length > 0) {
      if (data[0].comparison_point.length > 0) {
        // Check if "None" key is already present
        const isNoneKeyPresent = data[0].comparison_point.some(
          (itemConst: any) => itemConst.key === 'None'
        );
        // If the key is not present, add it
        if (!isNoneKeyPresent) {
          data[0].comparison_point.unshift({ key: 'None', value: true });
        }
        comparisionpoint = data[0].comparison_point.filter(
          (a: Config) => a.value == true
        );
        // Push other objects where value is true to comparison_point array
      }

      if (data[0].confidence_level.length > 0) {
        confidenceLevel = data[0].confidence_level.filter(
          (a: Config) => a.value == true
        );
      }

      if (data[0].weight.length > 0) {
        weights = data[0].weight.filter((a: any) => a.is_selected == true);
      }

      if (data[0].dataformat.length > 0) {
        dataFormat = data[0].dataformat.filter((a: any) => a.value == true);
      }

      this.selectedConfig.emit({
        RowNestSelection: data[0].nesting[0].is_selected,
        ColNestSelection: data[0].nesting[1].is_selected,
        is_brand_analysis: data[0].is_brand_analysis,
        is_chart_visualization: data[0].is_chart_visualization,
        is_sticky_selection: data[0].is_sticky_selection,
        is_reset_selection: data[0].is_reset_selection,
        is_Transpose: data[0].output_page[0].value,
        is_indexing: data[0].output_page[1].value,
        is_sigtesting: data[0].output_page[2].value,
        is_ranking: data[0].output_page[3].value,
        isFilterToggle: data[0].filter_function[0].value,
        isAnswerToggle: data[0].filter_function[1].value,
        comparisionpoint: comparisionpoint,
        confidenceLevel: confidenceLevel,
        excelExport: data[0].export_download[0].value,
        pptExport: data[0].export_download[1].value,
        repository: data[0].export_download[2].value,
        lowBaseIdentifier: data[0].export_download[3].value,
        is_AI_Integration: data[0].is_AI_Integration,
        is_StoryBoard: data[0].is_StoryBoard,
        is_Column_Row_Percentage: data[0].is_Column_Row_Percentage,
        insufficentBase: data[0].low_base_identifier[0].data_value,
        lowBase: data[0].low_base_identifier[1].data_value,
        threshold: data[0].threshold_identifier[0].data_value,
        configweights: weights,
        iscustomgrp: data[0].custom_content[0].value,
        iscustomCalc: data[0].custom_content[1].value,
        iscustomreport: data[0].custom_content[2].value,
        changeEntryPoint: data[0].save_selection[1].value,
        dataFormat: dataFormat.length > 0 ? dataFormat[0].key : '',
        isWeightedBase:
          data[0].aggregatedvariables[1].data_value == '' ? false : true,
        isSampleSize:
          data[0].aggregatedvariables[2].data_value == '' ? false : true,
        aggregatedVariables: data[0].aggregatedvariables,
        mandatoryVariableMapping: data[0].mandatory_variable_mapping,
        isSelectAllMetrics: data[0].is_SelectAll_Metrics,
        moduleDetails: data[0].moduledetails
      });
      this.dataFormat = dataFormat.length > 0 ? dataFormat[0].key : '';
      if (this.isEditAlert) {
        this.mandatoryVariableMapping = data[0].mandatory_variable_mapping || [];
        // dimension array may exist on payload (defensive)
        this.dimensionMeta = data[0].dimension || this.dimensionMeta;
      }
      this.sendHelpGuide.emit(data[0].help_guide);
      this.custom_calculation = data[0].custom_calculation;
      this.custom_group = data[0].custom_group;
      this.custom_report = data[0].custom_report;
      this.export_download = data[0].export_download;
      this.isconfigCustomGrpPresent =
        data[0].custom_content[0].value == true ? true : false;
      this.isconfigCustomCalcPresent =
        data[0].custom_content[1].value == true ? true : false;
      this.isSelectAllMetrics = data[0].is_SelectAll_Metrics;
    }
  }

 BindEntryData(
  data: any,
  selectedStudy: string,
  ClientCode: string,
  ZeroEntryPoint: boolean,
  landingDataPoint: boolean = false
) {
  this.studyname = selectedStudy;
  this.entryPanel = [];
  this.variableList = [];
  this.filteredStudies = _.uniq(
    _.map(
      _.filter(
        data,
        (item) =>
          item.study !== null &&
          item.study !== '' &&
          item.client_name == ClientCode
      ),
      'study'
    )
  );
  const Leve1 = _.uniq(
    _.map(
      _.filter(
        data,
        (item) =>
          item.Level1 !== null &&
          item.Level2 !== '' &&
          item.study == selectedStudy
      ),
      'Level1'
    )
  );
  for (const element of Leve1) {
    this.entryPanel.push({ Level1: element });
  }

  // Only auto-create base clientStudyInfo when NOT editing an alert
  if (!this.isEditAlert && (landingDataPoint || (ZeroEntryPoint && this.entryPanel.length == 0))) {
    this.dataArray = [];
    const clientStudyInfo: any = {
      clientName: this.selected_client,
      studyName: this.selected_study
    };
    this.dataArray.push(clientStudyInfo);
    this.loadBtnClick(false);
  } else if (this.isEditAlert && this.dataArray.length === 0) {
    // Edit alert but list empty (edge case) – create seeded object including meta
    const clientStudyInfo: any = {
      clientName: this.selected_client,
      studyName: this.selected_study,
      mandatory_variable_mapping: this.mandatoryVariableMapping,
      dimension: this.dimensionMeta
    };
    this.dataArray.push(clientStudyInfo);
  }

  if (this.moduleName == 'Custom SnapShot') {
    this.loadBtnClick(false);
  }
  if (this.moduleName == 'Brand Analysis' && this.isLoadSelected) {
    this.loadBtnClick(false);
    
  }
  if (this.moduleName == 'Crosstab' && this.isLoadSelected) {
    this.loadBtnClick(false);    
  }

  if(this.entryPanel.length> 0 && this.entryPanel.length == 1){
    this.entryExpand(this.entryPanel[0].Level1);
  }
}
  entryExpand(lvl1: string) {
    this.isStudyPanel = false;
    this.searchTextLevel2 = '';
    this.searchMetricOption = '';
    if (this.entry_items_expand == '') {
      this.entry_items_expand = lvl1;
      this.entryFlag = true;
    } else if (this.entry_items_expand == lvl1) {
      this.entry_items_expand = '';
      this.entryFlag = false;
    } else {
      this.entry_items_expand = lvl1;
      this.entryFlag = true;
    }

    this.LeftPanelClick.emit({
      entry_items_expand: this.entry_items_expand,
      entryFlag: this.entryFlag,
    });

    this.entryPanel_Lvl2 = [];
    this.sidePanelblock = false;
    let lvl2Update = this.Reciveddata.filter(
      (a: any) => a.Level1 === lvl1 && a.study == this.selected_study
    );
    lvl2Update = _.sortBy(lvl2Update, 'sortid');
    const Leve2 = _.uniq(
      _.map(
        _.filter(
          lvl2Update,
          (item) =>
            item.Level2 !== null && item.Level2 !== '' && item.Level1 == lvl1
        ),
        'Level2'
      )
    );
    for (const lvl2 of Leve2) {
      this.entryPanel_Lvl2.push({
        Level1: lvl1,
        Level2: lvl2,
      });
    } 
    if(this.entryPanel_Lvl2.length > 0 && this.entryPanel_Lvl2.length == 1){
      const index = this.entryPanel.findIndex((entry) => entry.Level1 === lvl1);
      if (index !== -1) {
        this.BindSidePanel(index, lvl1, this.entryPanel_Lvl2[0].Level2);
      }
    }
  }

  BindSidePanel(EntryDetails: number, lvl1: string, lvl2: string) {

    this.searchTextLevel2 = '';
    this.searchMetricOption = '';
    this.entryPanel_Lvl3 = [];
    if(this.levelName==lvl1+"|"+lvl2)
      this.sidePanelblock = !this.sidePanelblock;
    else
      this.sidePanelblock = true;
    this.levelName = lvl1+"|"+lvl2;
    this.selectAllCheck = 0;
    let lvl2Update = this.Reciveddata.filter(
      (a: any) =>
        a.Level1 === lvl1 && a.Level2 === lvl2 && a.study == this.selected_study
    );
    lvl2Update = _.sortBy(lvl2Update, 'sortid');
    this.metricOption = [];
    let uniqueMarket: any = [];
    let uniqueCate: any = [];
    this.dataArray.forEach((entry) => {
      const metricOptionsList1 = entry['EntryPoint1']?.Level2 || [];

      metricOptionsList1.forEach((data: any) => {
        data.MetricOptions.forEach((metricOption: any) => {
          this.metricOption.push(metricOption.responseCode);
          uniqueMarket.push(metricOption.responseCode);
        });
        //this.metricOption.push(data.responseCode);
      });

      const metricOptionsList2 = entry['EntryPoint2']?.Level2 || [];

      metricOptionsList2.forEach((data: any) => {
        data.MetricOptions.forEach((metricOption: any) => {
          this.metricOption.push(metricOption.responseCode);
          uniqueCate.push(metricOption.responseCode);
        });
      });

      const metricOptionsList3 = entry['EntryPoint3']?.Level2 || [];

      metricOptionsList3.forEach((data: any) => {
        data.MetricOptions.forEach((metricOption: any) => {
          this.metricOption.push(metricOption.responseCode);
        });
      });
    });

    const uniqueMetricOptionsArray = this.metricOption;

    const Leve2 = _.uniq(
      _.map(
        _.filter(
          lvl2Update,
          (item) =>
            item.Level1 === lvl1 &&
            item.Level2 === lvl2 &&
            item.MetricOption != ''
        ),
        'MetricOption'
      )
    );

    for (const lvl of Leve2) {
      let MetricOptions = this.Reciveddata.filter(
        (a: any) =>
          a.Level1 === lvl1 &&
          a.Level2 === lvl2 &&
          a.MetricOption == lvl &&
          a.study == this.selected_study
      );

      if (EntryDetails == 1) {
        MetricOptions = MetricOptions.filter((a: any) => {
          const optionCodes = a.e1_variable_code
            .split(',')
            .map((code: any) => code.trim());
          return optionCodes.some((code: any) =>
            uniqueMetricOptionsArray.includes(code)
          );
        });
        MetricOptions = MetricOptions.filter((x: any) => {
          return uniqueMarket.indexOf(x.e1_variable_code) > -1;
        });
      } else if (EntryDetails == 2) {
        MetricOptions = MetricOptions.filter((a: any) => {
          const optionCodes = a.e1_variable_code
            .split(',')
            .map((code: any) => code.trim());
          const optionCodes2 = a.e2_variable_code
            .split(',')
            .map((code: any) => code.trim());

          return (
            optionCodes.some((code: any) =>
              uniqueMetricOptionsArray.includes(code)
            ) ||
            optionCodes2.some((code: any) =>
              uniqueMetricOptionsArray.includes(code)
            )
          );
        });
        MetricOptions = MetricOptions.filter((x: any) => {
          return (
            uniqueMarket.indexOf(x.e1_variable_code) > -1 &&
            uniqueCate.indexOf(x.e2_variable_code) > -1
          );
        });
      }
      if (MetricOptions.length > 1) {
        MetricOptions = [MetricOptions[0]];
      }
      for (const metric of MetricOptions) {
        this.entryPanel_Lvl3.push({
          Level: EntryDetails,
          Level1: lvl1,
          Level2: lvl2,
          MetricOptions: metric.MetricOption,
          responseCode: metric.ResponseCode,
          isActive: false,
          variableCode: metric.VariableCode,
          e1_variable_code: metric.e1_variable_code,
          e2_variable_code: metric.e2_variable_code,
          e3_variable_code: metric.e3_variable_code,
          mandatory_variable_mapping: metric.mandatory_variable_mapping,
          dimension: metric.dimension,
        });
      }
    }

    const entryPointKey =
      EntryDetails === 0
        ? 'EntryPoint1'
        : EntryDetails === 1
          ? 'EntryPoint2'
          : 'EntryPoint3';
    const existingEntryIndex1 = this.dataArray.findIndex(
      (entry) =>
        entry.hasOwnProperty(entryPointKey) &&
        entry[entryPointKey].Level1 === lvl1
    );

    if (existingEntryIndex1 == -1) {
      this.isSelectAll = false;
    } else {
      const existingEntry = this.dataArray[existingEntryIndex1];

      const existingLevel2Index = existingEntry[entryPointKey].Level2.findIndex(
        (l2: any) => l2.Parent === lvl2
      );
      if (
        this.entryPanel_Lvl3.filter(
          (a) => a.Level1 === lvl1 && a.Level2 === lvl2
        ).length ===
        (existingLevel2Index !== -1
          ? existingEntry[entryPointKey].Level2[existingLevel2Index]
            .MetricOptions.length
          : 0)
      ) {
        this.isSelectAll = true;
      } else {
        const entryPanelOptions = this.entryPanel_Lvl3.map(
          (entry) => entry.MetricOptions
        );
        const isAllOptionsIncluded = entryPanelOptions.every((option) =>
          uniqueMetricOptionsArray.includes(option)
        );
        if (isAllOptionsIncluded) {
          this.isSelectAll = true;
        } else {
          this.isSelectAll = false;
        }
      }
    }
  }

  getVariableData(): void {
    if(this.isLoader){
     this.Loader.showLoader();
    }
    if (this.isEditAlert) {
      this.enrichDataArrayWithMeta();
    }
    this.$unSubscribeSubmitData3 = this.crossTabService
      .getVariableData(this.dataArray, this.isBrandAnalysis)
      .subscribe((result: results) => {
        // Response is valid
        if (result.HasValidData) {
          let JsonData = JSON.parse(result.Data);
          if (this.isBrandAnalysis) {
            JsonData.forEach((x: any) => {
              const is_multi_punch = x.is_multi_punch > 0 ? true : false;
              if (is_multi_punch) {
                x.MetricOption = '';
              }              
              switch (x.is_brandanalysis) {
                case 1:

                  x.Level2 = x.Level3;
                  x.Level3 = x.Level4;
                  x.Level4 = x.Level5;
                  x.Level5 = x.Level6;
                  x.Level6 = '';
                  // if (is_multi_punch && x.Level3 == '') {
                  //   x.MetricOption = '';
                  //   x.Level2 = '';
                  // } else if (is_multi_punch && x.Level3 !== '') {
                  //   x.Level2 = x.Level3;
                  //   x.Level3 = '';
                  //   // x.MetricOption = x.Level3;
                  //   // x.Level2 = '';
                  // } else if (is_multi_punch && x.Level4 !== '') {
                  //   x.MetricOption = x.Level4;
                  //   x.Level2 = x.Level3;
                  // } else if (is_multi_punch && x.Level5 !== '') {
                  //   x.MetricOption = x.Level5;
                  //   x.Level3 = x.Level4;
                  //   x.Level2 = x.Level3;
                  // } else if (is_multi_punch && x.Level6 !== '') {
                  //   x.MetricOption = x.Level6;
                  //   x.Level4 = x.Level5;
                  //   x.Level3 = x.Level4;
                  //   x.Level2 = x.Level3;
                  // } else {
                  //   x.Level2 = x.Level3;
                  //   x.Level3 = x.Level4;
                  //   x.Level4 = x.Level5;
                  // }
                  break;
                case 2:              
                  x.Level3 = x.Level4;
                  x.Level4 = x.Level5;
                  // if (is_multi_punch && x.Level4 == '') {
                  //   x.MetricOption = '';
                  //   x.Level3 = '';
                  // } else if (is_multi_punch && x.Level4 !== '') {
                  //   x.MetricOption = x.Level4;
                  //   x.Level3 = '';
                  // } else if (is_multi_punch && x.Level5 !== '') {
                  //   x.MetricOption = x.Level5;
                  //   x.Level3 = x.Level4;
                  // } else if (is_multi_punch && x.Level6 !== '') {
                  //   x.MetricOption = x.Level6;
                  //   x.Level4 = x.Level5;
                  //   x.Level3 = x.Level4;
                  // } else {
                  //   x.Level3 = x.Level4;
                  //   x.Level4 = x.Level5;

                  // }
                  break;
                case 3:
                  x.Level4 = x.Level5;
                  // if (is_multi_punch && x.Level5 == '') {
                  //   x.MetricOption = '';
                  //   x.Level4 = '';
                  // } else if (is_multi_punch && x.Level5 !== '') {
                  //   x.MetricOption = x.Level5;
                  //   x.Level4 = '';
                  // } else if (is_multi_punch && x.Level6 !== '') {
                  //   x.MetricOption = x.Level6;
                  //   x.Level4 = x.Level5;
                  // } else {
                  //   x.Level4 = x.Level5;
                  // }
                  break;
                case 4:
                  x.Level5 = '';
                  // if (is_multi_punch && x.Level6 == '') {
                  //   x.MetricOption = '';
                  //   x.Level6 = '';
                  // } else if (is_multi_punch && x.Level6 !== '') {
                  //   x.MetricOption = x.Level6;
                  //   x.Level6 = '';
                  // } else {
                  //   x.Level5 = '';
                  // }
                  break;
                case 5:
                  x.Level6 = '';
                  break;
                case 6:
                  x.MetricOption = '';
                  break;
              }
            });
          }
           if (this.moduleName === 'Alert') {
            JsonData = this.addSyntheticLatestPrevious(JsonData);
          }
          this.variableTabData = JsonData;
           if (this.isEditAlert) {
            setTimeout(() => { this.variableDataReady.emit();this.Loader.hideLoader(); }, 0);
          }else{
            this.Loader.hideLoader();
          }
          
          if (this.variableTabData.length > 0) {
            this.isAggregatedData =
              this.variableTabData[0].is_aggregated_data == 1 ? true : false;
            this.isSemiAggregatedData =
              this.variableTabData[0].is_semi_aggregated_data == 1
                ? true
                : false;
            this.BindVariableDataLeftPanel(this.variableTabData);
            this.crossTabService.setVariableTabData(this.variableTabData);
          }
        } else {
          this.errorPopup(result.ExceptionMessage);
          this.Loader.hideLoader();
        }
        //hide the loader
      });
  }

  BindVariableDataLeftPanel(Variableresult: any): void {
    this.variableList = [];
    this.isVariableTab = true;
    this.is_load_btn = false;
    this.isEntry_Tab = false;
    this.sidePanelblock = false;
    this.isEntry_Point = false;
    this.isStudyPanel = false;
    this.entry_items_expand = '';
    this.dimensionList = [];
    this.btnVisible.emit({
      save: true,
      load: true,
      custom_groups: this.isconfigCustomGrpPresent ? true : false,
      custom_calc: this.isconfigCustomCalcPresent ? true : false,
      create_table: true,
      weighted_btns: true,
    });
    this.entryListChange.emit(this.entryPanel);
    this.dataListChange.emit(this.dataArray);

    const result = _.sortBy(Variableresult, 'sort_id');
    this.dimensionList = _.uniq(
      _.map(
        _.filter(result, (item) => item.is_dimension),
        'Level0'
      )
    );
    this.dimensionListChange.emit(this.dimensionList);
    let matchFound;
    const Level0Variables = _.uniq(_.map(result, 'Level0'));
    for (let i = 0; i < Level0Variables.length; i++) {
      const level0 = Level0Variables[i];
      const listToUpdate = _.filter(
        result,
        (a) => a.Level0 === Level0Variables[i]
      );
      const Level1Variables = _.uniq(_.map(listToUpdate, 'Level1'));
      const level1Array = Level1Variables.map((level1) => {
        const filteredItems = _.filter(
          listToUpdate,
          (item) => item.Level1 === level1
        );
        const is_brand_analysis = _.map(filteredItems, 'is_brandanalysis')[0];
        const derived = _.uniq(
          _.map(filteredItems, 'is_derived_variable')
        ).toString();
        const calc = _.uniq(
          _.map(filteredItems, 'calculation_type')
        ).toString();
        const tooltip = _.uniq(_.map(filteredItems, 'tooltip')).toString();
        const data_variable_code = _.uniq(
          _.map(filteredItems, 'data_variable_code')
        ).toString();
        const response_code = _.uniq(
          _.map(filteredItems, 'response_code')
        ).toString();
        const sort_id = _.uniq(_.map(filteredItems, 'sort_id')).toString();
        const is_multi_punch = _.uniq(
          _.map(filteredItems, 'is_multi_punch')
        ).toString();
        const date = _.uniq(_.map(filteredItems, 'date')).toString();
        const year_code = _.uniq(_.map(filteredItems, 'year_code')).toString();
        const dimension = _.uniq(
          _.map(filteredItems, 'is_dimension')
        ).toString();
        const is_custom_group = _.uniq(
          _.map(filteredItems, 'is_CustomGroup')
        ).toString();
        const is_custom_calculation = _.uniq(
          _.map(filteredItems, 'is_CustomCalculation')
        ).toString();
        const customGroupQuery = _.uniq(
          _.map(filteredItems, 'customGroupQuery')
        ).toString();
        const customCalculationQuery = _.uniq(
          _.map(filteredItems, 'customCalculationQuery')
        ).toString();
        const customGroupId = _.uniq(
          _.map(filteredItems, 'customGroupId')
        ).toString();
        const customCalculationId = _.uniq(
          _.map(filteredItems, 'customCalculationId')
        ).toString();
        const dataYearCode = _.uniq(
          _.map(filteredItems, 'dataYearCode')
        ).toString();
        const is_time_Period_Present = _.uniq(
          _.map(filteredItems, 'is_time_Period_Present')
        ).toString();
        const Weekno_forSigcalculation = _.uniq(
          _.map(filteredItems, 'Weekno_forSigcalculation')
        ).toString();
        const Level2Variables = _.uniq(
          _.map(
            _.filter(
              result,
              (item) =>
                item.Level0 === level0 &&
                item.Level1 === level1 &&
                (item.MetricOption !== '' || item.Level2 !== '')
            ),
            'Level2'
          )
        );
        matchFound =
          this.isBrandAnalysis && Level0Variables[i] === 'Brands'
            ? true
            : this.entryPanel.some((entry) =>
              this.entryPanel.some(
                (listItem) => entry.Level1 === Level0Variables[i]
              )
            )
              ? true
              : false;
        return {
          Level1_value: level1,
          is_derived: derived,
          is_brand_analysis: is_brand_analysis,
          calc_type: calc,
          tooltip: tooltip,
          hasNextLevel: Level2Variables.length > 0,
          data_variable_code: data_variable_code,
          response_code: response_code,
          sort_id: sort_id,
          is_multi_punch: is_multi_punch,
          date: date,
          year_code: year_code,
          is_dimension: dimension,
          isCustomGrpPresent: is_custom_group,
          isCustomCalcPresent: is_custom_calculation,
          kibanaFilterScript:
            is_custom_group.toString() == 'true'
              ? customGroupQuery
              : is_custom_calculation.toString() == 'true'
                ? customCalculationQuery
                : '',
          dataYearCode: dataYearCode,
          is_time_Period_Present: is_time_Period_Present,
          customGroupId: customGroupId,
          customCalculationId: customCalculationId,
          Weekno_forSigcalculation: Weekno_forSigcalculation
        };
      });

      if(!this.isCreateCustomGroup || (this.isCreateCustomGroup && (this.dataFormat == 'Respondent Level'? matchFound == true ? true : false : true) != true))
        this.variableList.push({
          Level0: level0,
          isEntryPoint:
            this.dataFormat == 'Respondent Level'
              ? matchFound == true
                ? true
                : false
              : true,

          Level1: level1Array,
          hasOnlyBrandIndependentChildren: level1Array[0].isCustomGrpPresent == "false" ?  level1Array
            .map((a) => a.is_brand_analysis)
            .every((a) => a === 0 || a === 7) : false,
          hasOnlyBrandDependentChildren:  level1Array[0].isCustomGrpPresent == "true" 
            ? true : level1Array[0].isCustomCalcPresent == "true" ? false : level1Array
            .map((a) => a.is_brand_analysis)
            .every((a) => a !== 0 && a !== 7),
          hasSomeBrandDependentChildrenNotAll:
            level1Array
              .map((a) => a.is_brand_analysis)
              .some((a) => a !== 0 && a !== 7) &&
              level1Array
                .map((a) => a.is_brand_analysis)
                .some((a) => a === 0 || a === 7)
              ? true
              : false,
        });
    }
          if (this.moduleName == 'Alert') {
        this.variableList = this.variableList.filter(
          (a) =>
            a.Level0 != 'Custom Percentage Variable - User Defined' &&
            a.Level0 != 'Custom Percentage Variable - Shared With Me' &&
            a.Level0 != 'Custom Mean Variable - User Defined' &&
            a.Level0 != 'Custom Mean Variable - Shared With Me'
        );
      }
    if(this.moduleName == 'Custom SnapShot' || this.isCreateCustomGroup){
      let list = this.variableList.filter(
        (a) =>
          a.Level0 != 'Markets' &&
          a.Level0 != 'Time Period' &&
          a.Level0 != 'Custom Percentage Variable - User Defined' &&
          a.Level0 != 'Custom Percentage Variable - Shared With Me' &&
          a.Level0 != 'Custom Mean Variable - User Defined' &&
          a.Level0 != 'Custom Mean Variable - Shared With Me'
        );
     this.variableList = list;
  }

    this.dimensionList = _.uniq(
      _.map(
        _.filter(result, (item) => item.is_dimension == true),
        'Level0'
      )
    );
    this.dimensionListChange.emit(this.dimensionList);
    this.variableList = _.sortBy(this.variableList, 'sort_id');

    // Hide 3MMA and 4MMA from the Time Period group
    const timePeriodVar = this.variableList.find((v: any) => v.Level0 === 'Time Period');
    if (timePeriodVar) {
      timePeriodVar.Level1 = timePeriodVar.Level1.filter(
        (l1: any) => l1.Level1_value !== '3MMA' && l1.Level1_value !== '4MMA'
      );
    }

    if (this.isBrandAnalysis) {
      const dependentList = this.variableList.filter(
        (a) => a.hasOnlyBrandDependentChildren || a.hasSomeBrandDependentChildrenNotAll
      );
      const independentList = this.variableList.filter(
        (a) => a.hasOnlyBrandIndependentChildren || a.hasSomeBrandDependentChildrenNotAll
      );

      // sort again after dividing into BD(Brand Dependent) and BI(Brand Independent).
      // Example:
      // After dividing I have the below metrics in BI: Metrics - sort_id
      // ad hoc - marital status - 567307
      // demographics - male - 782277
      // ad hoc - Education - 1182590
      // Since there is atleast one record of ad hoc with sort_id less than that of demographics, all ad hoc metrics will come before demographics in left panel. 
      
      // For BI sorting: only consider Level1 items that are brand independent (is_brand_analysis === 0 || 7)
      this.brandIndependentVariableList = _.sortBy(
        independentList.map((group) => ({
          ...group,
          _section_sort_id: Math.min(
            ...group.Level1
              .filter((l1: any) => l1.is_brand_analysis === 0 || l1.is_brand_analysis === 7)
              .map((l1: any) => Number(l1.sort_id.split(',')[0]))  // split and take first
          )
        })),
        '_section_sort_id'
      );

      // For BD sorting: only consider Level1 items that are brand dependent (is_brand_analysis !== 0 && !== 7)
      this.brandDependentVariableList = _.sortBy(
        dependentList.map((group) => ({
          ...group,
          _section_sort_id: Math.min(
            ...group.Level1
              .filter((l1: any) => l1.is_brand_analysis !== 0 && l1.is_brand_analysis !== 7)
              .map((l1: any) => Number(l1.sort_id.split(',')[0]))  // split and take first
          )
        })),
        '_section_sort_id'
      );
    }
    //let listToUpdate;
    //const Level0Variables = _.uniq(_.map(_.filter(result, item => item.Level0 !== null && item.Level0 !== ''), 'Level0'));
    //if (Level0Variables.length > 0) {
    //  for (let i = 0; i < Level0Variables.length; i++) {
    //    const level0 = Level0Variables[i];
    //    let matchFound = this.entryPanel.some((entry) =>
    //      this.entryPanel.some(
    //        (listItem) => entry.Level1 === Level0Variables[i]
    //      )
    //    );
    //    listToUpdate = result.filter((a) => a.Level0 === Level0Variables[i]);
    //    listToUpdate = _.sortBy(listToUpdate, 'sort_id');
    //    const Level1Variables = _.uniq(
    //      _.map(
    //        _.filter(
    //          listToUpdate,
    //          (item) =>
    //            item.Level0 !== null &&
    //            item.Level0 !== '' &&
    //            item.Level0 == Level0Variables[i] &&
    //            item.Level1 != '' &&
    //            item.Level1 != null
    //        ),
    //        'Level1'
    //      )
    //    );
    //    const level1Array: {
    //      Level1_value: string;
    //      is_derived: string;
    //      is_brand_analysis: number;
    //      calc_type: string;
    //      tooltip: string;
    //      hasNextLevel: boolean;
    //      data_variable_code: string;
    //      response_code: string;
    //      sort_id: string;
    //      is_multi_punch: string;
    //      date: string;
    //      year_code: string;
    //      is_dimension: string;
    //      isCustomGrpPresent: string;
    //      kibanaFilterScript: string;
    //      dataYearCode: string;
    //      is_time_Period_Present: string;
    //      customGroupId: string;

    //    }[] = [];
    //    for (let j = 0; j < Level1Variables.length; j++) {
    //      const level1 = Level1Variables[j];
    //      let is_derived = _.uniq(
    //        _.map(
    //          _.filter(
    //            listToUpdate,
    //            (item) =>
    //              item.Level0 === Level0Variables[i] &&
    //              item.Level1 == Level1Variables[j]
    //          ),
    //          'is_derived_variable'
    //        )
    //      );
    //      let calc_type = _.uniq(
    //        _.map(
    //          _.filter(
    //            listToUpdate,
    //            (item) =>
    //              item.Level0 === Level0Variables[i] &&
    //              item.Level1 == Level1Variables[j]
    //          ),
    //          'calculation_type'
    //        )
    //      );
    //      let tooltip_info = _.uniq(
    //        _.map(
    //          _.filter(
    //            listToUpdate,
    //            (item) =>
    //              item.Level0 === Level0Variables[i] &&
    //              item.Level1 == Level1Variables[j]
    //          ),
    //          'tooltip'
    //        )
    //      );

    //      let dvariable_code = _.uniq(
    //        _.map(
    //          _.filter(
    //            listToUpdate,
    //            (item) =>
    //              item.Level0 === Level0Variables[i] &&
    //              item.Level1 == Level1Variables[j]
    //          ),
    //          'data_variable_code'
    //        )
    //      );

    //      let r_code = _.uniq(
    //        _.map(
    //          _.filter(
    //            listToUpdate,
    //            (item) =>
    //              item.Level0 === Level0Variables[i] &&
    //              item.Level1 == Level1Variables[j]
    //          ),
    //          'response_code'
    //        )
    //      );

    //      let sorting_id = _.uniq(
    //        _.map(
    //          _.filter(
    //            listToUpdate,
    //            (item) =>
    //              item.Level0 === Level0Variables[i] &&
    //              item.Level1 == Level1Variables[j]
    //          ),
    //          'sort_id'
    //        )
    //      );

    //      let multi_punch = _.uniq(
    //        _.map(
    //          _.filter(
    //            listToUpdate,
    //            (item) =>
    //              item.Level0 === Level0Variables[i] &&
    //              item.Level1 == Level1Variables[j]
    //          ),
    //          'is_multi_punch'
    //        )
    //      );

    //      let dateVal = _.uniq(
    //        _.map(
    //          _.filter(
    //            listToUpdate,
    //            (item) =>
    //              item.Level0 === Level0Variables[i] &&
    //              item.Level1 == Level1Variables[j]
    //          ),
    //          'date'
    //        )
    //      );

    //      let y_code = _.uniq(
    //        _.map(
    //          _.filter(
    //            listToUpdate,
    //            (item) =>
    //              item.Level0 === Level0Variables[i] &&
    //              item.Level1 == Level1Variables[j]
    //          ),
    //          'year_code'
    //        )
    //      );

    //      let is_dimension = _.uniq(
    //        _.map(
    //          _.filter(
    //            listToUpdate,
    //            (item) =>
    //              item.Level0 === Level0Variables[i] &&
    //              item.Level1 == Level1Variables[j]
    //          ),
    //          'is_dimension'
    //        )
    //      );

    //      let is_custom_group = _.uniq(
    //        _.map(
    //          _.filter(
    //            listToUpdate,
    //            (item) =>
    //              item.Level0 === Level0Variables[i] &&
    //              item.Level1 == Level1Variables[j]
    //          ),
    //          'is_CustomGroup'
    //        )
    //      );

    //      let customGroupQuery = _.uniq(
    //        _.map(
    //          _.filter(
    //            listToUpdate,
    //            (item) =>
    //              item.Level0 === Level0Variables[i] &&
    //              item.Level1 == Level1Variables[j]
    //          ),
    //          'customGroupQuery'
    //        )
    //      );
    //      let customGroupId = _.uniq(
    //        _.map(
    //          _.filter(
    //            listToUpdate,
    //            (item) =>
    //              item.Level0 === Level0Variables[i] &&
    //              item.Level1 == Level1Variables[j]
    //          ),
    //          'customGroupId'
    //        )
    //      );

    //      let dataYearCodeVariable = _.uniq(
    //        _.map(
    //          _.filter(
    //            listToUpdate,
    //            (item) =>
    //              item.Level0 === Level0Variables[i] &&
    //              item.Level1 == Level1Variables[j]
    //          ),
    //          'dataYearCode'
    //        )
    //      );

    //      let istimePeriodPresent = _.uniq(
    //        _.map(
    //          _.filter(
    //            listToUpdate,
    //            (item) =>
    //              item.Level0 === Level0Variables[i] &&
    //              item.Level1 == Level1Variables[j]
    //          ),
    //          'is_time_Period_Present'
    //        )
    //      );

    //      let Level2Variables = _.uniq(
    //        _.map(
    //          _.filter(
    //            result,
    //            (item) =>
    //              item.Level0 === Level0Variables[i] &&
    //              item.Level1 == Level1Variables[j] &&
    //              (item.MetricOption != '' || item.Level2 != '')
    //          ),
    //          'Level2'
    //        )
    //      );
    //      const filteredItems = _.filter(
    //        listToUpdate,
    //        (item) =>
    //          item.Level0 === Level0Variables[i] &&
    //          item.Level1 == Level1Variables[j]
    //      );
    //      const is_brand_analysis = _.map(filteredItems, 'is_brandanalysis')[0];

    //      if (this.isBrandAnalysis && Level0Variables[i] === "Brands") {
    //        matchFound = true;
    //      }
    //      const derived = is_derived.toString();
    //      const calc = calc_type.toString();
    //      const tooltip = tooltip_info.toString();
    //      const data_variable_code = dvariable_code.toString();
    //      const response_code = r_code.toString();
    //      const sort_id = sorting_id.toString();
    //      const is_multi_punch = multi_punch.toString();
    //      const date = dateVal.toString();
    //      const year_code = y_code.toString();
    //      const dimension = is_dimension.toString();
    //      const custom_grp = is_custom_group.toString();
    //      const custmGrpQery = customGroupQuery.toString();
    //      const custmGrpId = customGroupId.toString();
    //      const dataYearCode = dataYearCodeVariable.toString();
    //      const is_time_Period_Present = istimePeriodPresent.toString();
    //      level1Array.push({
    //        Level1_value: level1,
    //        is_derived: derived,
    //        is_brand_analysis: is_brand_analysis,
    //        calc_type: calc,
    //        tooltip: tooltip,
    //        hasNextLevel: matchFound
    //          ? true
    //          : Level2Variables.length > 0
    //            ? true
    //            : false,
    //        data_variable_code: data_variable_code,
    //        response_code: response_code,
    //        sort_id: sort_id,
    //        is_multi_punch: is_multi_punch,
    //        date: date,
    //        year_code: year_code,
    //        is_dimension: dimension,
    //        isCustomGrpPresent: custom_grp,
    //        kibanaFilterScript: custmGrpQery,
    //        dataYearCode: dataYearCode,
    //        is_time_Period_Present: is_time_Period_Present,
    //        customGroupId: custmGrpId
    //      });
    //    }
    //    this.variableList.push({
    //      Level0: level0,
    //      isEntryPoint: matchFound == true ? true : false,
    //      Level1: level1Array,
    //    });
    //  }
    //}
  }

  IsDimension(parentOption: any) {
    return this.dimensionList.includes(parentOption);
  }

  ClearAll(): void {
    this.isVariableTab = false;
    this.is_load_btn = true;
    this.isClearEverything.emit();
  }

  // Listen for click events on the document.
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    // Check if the click event occurred outside the <div> block.
    if (!this.isClickInside(event, '.sidePanelblock')) {
    }
  }

  private isClickInside(event: Event, className: string): boolean {
    const elements = document.querySelectorAll(className);
    for (let i = 0; i < elements.length; i++) {
      const container = elements[i];
      if (container.contains(event.target as Node)) {
        return true;
      }
    }
    return false;
  }

  selectAll(Parent: string, Selection: string) {
    this.isSelectAll = !this.isSelectAll;
    let selectedList: any[] = [];
    let callback: ((item: any) => void) | undefined = undefined;
    selectedList = this.entryPanel_Lvl3;
    callback = (item) =>
      this.checkBoxClick(
        0,
        item.Level,
        '',
        item.Level1,
        item.Level2,
        item.MetricOptions,
        item.variableCode,
        item.responseCode,
        item.mandatory_variable_mapping,
        this.isSelectAll,
        item.e1_variable_code,
        item.e2_variable_code,
        item.e3_variable_code,
        item.dimension
      );
    if (selectedList && callback) {
      this.processSelectedList(selectedList, callback);
    }
  }
  private processSelectedList(
    selectedList: any[],
    callback: (item: any) => void
  ): void {
    for (const item of selectedList) {
      callback(item);
    }
  }
  private enrichDataArrayWithMeta(): void {
    if (!this.isEditAlert) return;
    this.dataArray = (this.dataArray || []).map(e => ({
      ...e,
      mandatory_variable_mapping: this.mandatoryVariableMapping,
      dimension: this.dimensionMeta
    }));
  }

private addSyntheticLatestPrevious(data: any[]): any[] {
  if (!Array.isArray(data)) return data;

  // Remove any prior synthetic rows
  data = data.filter(r =>
    !(r.Level0 === 'Time Period' &&
      (r.isSyntheticLatestPrevious ||
       r.Level1 === 'Latest' ||
       r.Level1 === 'Previous'))
  );

  // All original time period rows (real)
  const original = data.filter(r =>
    r.Level0 === 'Time Period' &&
    r.Level1 &&
    r.Level1 !== '' &&
    r.Level1 !== 'Latest' &&
    r.Level1 !== 'Previous'
  );
  if (!original.length) return data;

  // Group by granularity (original Level1)
  const groups = new Map<string, any[]>();
  original.forEach(r => {
    const key = r.Level1.trim();
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key)!.push(r);
  });

  // Date ordering (latest first)
  const monthMap: Record<string, number> = {
    jan:0,feb:1,mar:2,apr:3,may:4,jun:5,jul:6,aug:7,sep:8,oct:9,nov:10,dec:11
  };
  const toTs = (row: any): number => {
    if (row.date) {
      const t = Date.parse(row.date);
      if (!isNaN(t)) return t;
    }
    const raw = (row.MetricOption || '').toString().trim();
    let m = raw.match(/^([A-Za-z]{3})[- ]?(\d{2})$/);
    if (m) {
      const y = 2000 + parseInt(m[2],10);
      const mo = monthMap[m[1].toLowerCase()];
      if (mo !== undefined) return Date.UTC(y, mo, 1);
    }
    let q = raw.replace(/\s+/g,'').match(/^Q([1-4])-(\d{2})$/i);
    if (q) {
      const y = 2000 + parseInt(q[2],10);
      const qi = parseInt(q[1],10)-1;
      return Date.UTC(y, qi*3, 1);
    }
    let y4 = raw.match(/^(\d{4})$/);
    if (y4) return Date.UTC(parseInt(y4[1],10),0,1);
    return 0;
  };

  // Sort ids so synthetics appear first
  const existingSortIds = original
    .map(r => parseInt(r.sort_id,10))
    .filter(v => !isNaN(v));
  const baseSort = existingSortIds.length ? Math.min(...existingSortIds) : 0;
  let cursor = baseSort - 4000;

  const synthetic: any[] = [];

  const build = (group:'Latest'|'Previous', gran: string, base: any) => {
    if (!base) return;
    synthetic.push({
      ...base,
      Level0: 'Time Period',
      Level1: group,
      Level2: '',                  // force NO further iteration
      MetricOption: gran,          // granularity shown as checkbox text
      // store real period info
      syntheticValue: base.MetricOption,
      syntheticResponseCode: base.response_code,
      syntheticYearCode: base.year_code,
      tooltip: `${group}|${gran}|${base.MetricOption}`,
      sort_id: (cursor++).toString(),
      isSyntheticLatestPrevious: true,
      // wipe deeper levels
      Level3: '',
      Level4: '',
      Level5: '',
      Level6: ''
    });
  };

  groups.forEach((rows, gran) => {
    rows.forEach(r => r.__ts = toTs(r));
    rows.sort((a,b) => b.__ts - a.__ts);
    const latest = rows[0];
    const previous = rows[1]; // may be undefined
    build('Latest', gran, latest);
    build('Previous', gran, previous);
  });

  if (!synthetic.length) return data;

  // Merge & resort only Time Period rows
  const others = data.filter(r => r.Level0 !== 'Time Period');
  const mergedTP = [...data.filter(r => r.Level0 === 'Time Period'), ...synthetic]
    .sort((a,b) => (parseInt(a.sort_id,10)||0) - (parseInt(b.sort_id,10)||0));

  return [...others, ...mergedTP];
}

// Helper (use when converting a selected synthetic row into real period codes)
private mapSyntheticSelection(row:any){
  if(row?.isSyntheticLatestPrevious){
    return {
      display: row.MetricOption,         // e.g. 'Year'
      actualPeriod: row.syntheticValue,  // e.g. '2024'
      responseCode: row.syntheticResponseCode,
      yearCode: row.syntheticYearCode
    };
  }
  return null;
}

// Helper to check if a variable has any visible children based on search
hasVisibleChildren(variable: any, searchText: string, innerSearchText: string = ''): boolean {
  if (!searchText && !innerSearchText) {
    return true; // If no search, show all
  }
  
  const lowerSearchText = searchText ? searchText.toLowerCase() : '';
  const lowerInnerSearchText = innerSearchText ? innerSearchText.toLowerCase() : '';
  
  // Check if any Level1 child matches the search
  if (variable.Level1 && variable.Level1.length > 0) {
    return variable.Level1.some((level1: any) => {
      // Check if Level1_value matches either search text
      const matchesTopSearch = lowerSearchText && level1.Level1_value && 
        level1.Level1_value.toLowerCase().includes(lowerSearchText);
      const matchesInnerSearch = lowerInnerSearchText && level1.Level1_value && 
        level1.Level1_value.toLowerCase().includes(lowerInnerSearchText);
      
      return matchesTopSearch || matchesInnerSearch;
    });
  }
  
  return false;
}

}
